/* Modulo: Product Shelf — variant select + add to cart on a product grid.

   The cart engine is adapted from modulo-section-product-quickbuy.js, which is
   itself adapted from the bundle block. Keep the hard-won parts: the r.ok gate
   (fetch does NOT reject on 422), the card-level in-flight flag, the drawer
   probe that covers Horizon's property setter, and routes.root for markets.

   What is new here is the picker. The buy row is a real <form>, so with
   JavaScript disabled it posts natively and Shopify redirects to the cart —
   this script only upgrades that to an ajax add. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  /* Markets: never hardcode '/cart' or '/checkout'. window.Shopify.routes.root
     is the only value documented as always ending in a '/'. On a Nordic
     subfolder market it is '/en-se/', and a literal path throws away the
     shopper's currency — invisible on a US primary market, which is exactly
     why it ships. */
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* fetch does NOT reject on 422. Without this gate, .then(r => r.json())
     parses Shopify's error body happily and a failed add reports success.
     Surfaces the real reason ("...is already sold out") instead of "Error". */
  function thenJson(r) {
    if (r.ok) return r.json();
    return r.text().then(function (t) {
      var body = null;
      try { body = JSON.parse(t); } catch (e) { /* not JSON; fall through */ }
      var reason = (body && (body.description || body.message)) ||
                   (t && t.slice(0, 140)) ||
                   r.statusText ||
                   'Could not add to cart';
      var err = new Error(reason);
      err.status = r.status;
      throw err;
    });
  }

  var DRAWER_QS = ['cart-drawer', 'cart-drawer-component', 'cart-notification', '[is="cart-drawer"]', '[data-cart-drawer]'];
  function findDrawer() {
    for (var i = 0; i < DRAWER_QS.length; i++) {
      var d = document.querySelector(DRAWER_QS[i]);
      if (d) return d;
    }
    return null;
  }

  /* Ask for the theme's own cart sections so the header count actually
     updates. Without this the drawer opens STALE, which is worse than not
     opening it at all. */
  function sectionList(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        var names = drawer.getSectionsToRender()
          .map(function (s) { return s.section || s.id; })
          .filter(Boolean);
        if (names.length) return names.join(',');
      } catch (e) { /* fall through to the generic list */ }
    }
    return 'cart-drawer,cart-icon-bubble,cart-notification,cart-live-region-text,cart-drawer-component';
  }

  /* Returns a LIVE drawer node. Dawn's <cart-drawer> owns its own rendering,
     so prefer renderContents. Otherwise graft — but the graft replaces the
     children of #shopify-section-cart-drawer, which DESTROYS the node the
     caller is holding, so it must re-query. Opening the detached original is a
     silent no-op: the drawer never appears and, on themes that scroll-lock
     from the open handler, the page can lock behind nothing. */
  function refreshCart(drawer, data) {
    if (!data || !data.sections) return drawer;
    if (drawer && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(data);
        return drawer;
      } catch (e) { /* fall through to the graft */ }
    }
    graftSections(data);
    return findDrawer();
  }

  function graftSections(data) {
    if (!data || !data.sections) return;
    for (var key in data.sections) {
      if (!Object.prototype.hasOwnProperty.call(data.sections, key)) continue;
      var id = 'shopify-section-' + key;
      var target = document.getElementById(id);
      var html = data.sections[key];
      if (!target || !html) continue;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('#' + id);
      if (!parsed) continue;
      while (target.firstChild) target.removeChild(target.firstChild);
      while (parsed.firstChild) target.appendChild(parsed.firstChild);
    }
  }

  /* Themes vary wildly. Modern Dawn exposes .open(); some forks .openDrawer();
     Horizon exposes `open` as a PROPERTY setter (which a typeof === 'function'
     check silently skips); older Dawn/Brooklyn use a <details> open attribute. */
  function openDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    if (typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
    if (typeof drawer.openDrawer === 'function') { try { drawer.openDrawer(); return; } catch (e) {} }
    if ('open' in drawer && typeof drawer.open !== 'function') { try { drawer.open = true; return; } catch (e) {} }
    if (drawer.tagName === 'DETAILS') { drawer.setAttribute('open', ''); return; }
    drawer.classList.add('active', 'is-active', 'open', 'is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  /* The real label is stashed on first use and never re-read from the DOM. The
     card's busy flag is released as soon as the request settles, but the flash
     runs for another ~1.8s — so a second click lands mid-flash. Reading
     textContent again there would capture "Added" as the original, and the
     button would read "Added" forever. */
  function flash(button, text, ms, announce) {
    var label = button.querySelector('.modulo-psh__atc-label');
    if (!label) return;
    if (!button.dataset.pshLabel) button.dataset.pshLabel = label.textContent;
    var original = button.dataset.pshLabel;
    if (button.pshTimer) clearTimeout(button.pshTimer);
    label.textContent = text;

    /* A textContent swap on the button the shopper is standing on is not
       reliably announced as an accessible-name change. Mirror every flash —
       success AND error — into the section's live region. `announce` is the
       UNTRUNCATED reason: the label is clipped to fit a card-width button and
       lands mid-word, but a live region has no width to run out of.
       textContent, never innerHTML: this is Shopify's own error text. */
    var sectionEl = button.closest('[data-modulo-psh]');
    var live = sectionEl && sectionEl.querySelector('[data-modulo-psh-live]');
    if (live) live.textContent = announce || text;

    button.pshTimer = setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-added');
      /* Cleared with the label: a stale "Added" left sitting in the region
         gets re-read on the next unrelated focus change. */
      if (live) live.textContent = '';
      button.pshTimer = null;
    }, ms);
  }

  /* The in-flight flag lives on the CARD, not the button — a per-button flag
     cannot see a sibling. Serializing here also keeps us clear of the HTTP 409
     Shopify returns for simultaneous cart requests. */
  function claim(card) {
    if (!card || card.dataset.pshBusy === '1') return false;
    card.dataset.pshBusy = '1';
    return true;
  }
  function release(card) {
    if (card) card.dataset.pshBusy = '0';
  }

  /* ─── Variant picker ───
     Every string comes pre-rendered from Liquid. This never formats money: a
     theme's own formatMoney is hostile (Ella throws on a one-arg call), and
     Intl would ignore the shop's money format entirely. */
  function syncVariant(card) {
    var select = card.querySelector('[data-psh-select]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    var priceEl = card.querySelector('[data-psh-price]');
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

    var wasEl = card.querySelector('[data-psh-was]');
    if (wasEl) {
      if (opt.dataset.compare) {
        wasEl.textContent = opt.dataset.compare;
        wasEl.hidden = false;
      } else {
        wasEl.textContent = '';
        wasEl.hidden = true;
      }
    }

    /* The badge is updated from the SAME option as the price, so a discount
       chip can never disagree with the figure beside it. A merchant tag badge
       is product-level and is left alone. */
    var badge = card.querySelector('[data-psh-badge]');
    if (badge && !badge.classList.contains('modulo-psh__badge--tag') &&
        !badge.classList.contains('modulo-psh__badge--out')) {
      if (opt.dataset.off) {
        badge.textContent = opt.dataset.off;
        badge.classList.add('modulo-psh__badge--sale');
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.classList.remove('modulo-psh__badge--sale');
        badge.hidden = true;
      }
    }

    /* ─── Quantity follows the variant.
       Both controls exist on every card now, so the quantity list has to
       re-open when the shopper switches to a variant with more stock and
       close when they switch to one with less. The full 1..N list is always
       in the DOM and Liquid ships the out-of-stock tail `disabled hidden` for
       the variant the card opened on; this is the same edit applied to the
       one they just chose. Rebuilding the list instead would throw away the
       server-rendered no-JS state for no gain.

       `disabled` AND `hidden`: hidden is what removes the option from the
       menu, disabled is what stops a theme script or an autofill from
       selecting it anyway.

       The clamp DOWN is the load-bearing half. Picking 8 of a variant with 10
       and then switching to one with 2 left would otherwise post a quantity
       Shopify rejects — a 422 the shopper cannot see the cause of, on a
       button that looked like it worked. */
    var qtySelect = card.querySelector('[data-psh-qty]');
    if (qtySelect) {
      var qtyMax = parseInt(opt.dataset.qtyMax, 10);
      if (!(qtyMax > 0)) qtyMax = qtySelect.options.length;
      for (var q = 0; q < qtySelect.options.length; q++) {
        var beyond = (q + 1) > qtyMax;
        qtySelect.options[q].disabled = beyond;
        qtySelect.options[q].hidden = beyond;
      }
      if (qtySelect.selectedIndex + 1 > qtyMax) qtySelect.selectedIndex = qtyMax - 1;
    }

    /* A disabled <option> cannot normally be selected, so this only fires if a
       theme script or an extension selects one programmatically. Cheap
       insurance against a shopper adding an unavailable variant. */
    var button = card.querySelector('[data-psh-add]');
    if (button) {
      var available = opt.dataset.available !== '0';
      button.disabled = !available;
      var label = button.querySelector('.modulo-psh__atc-label');
      if (label && !button.pshTimer) {
        var soldLabel = button.getAttribute('data-sold-label') || 'Sold out';
        if (!button.dataset.pshLabel) button.dataset.pshLabel = label.textContent;
        label.textContent = available ? button.dataset.pshLabel : soldLabel;
      }
    }
  }

  function addToCart(form, button, card) {
    if (!claim(card)) return;
    var drawer = findDrawer();
    var field = form.querySelector('[name="id"]');
    var variantId = field && field.value;
    if (!variantId) { release(card); return; }

    /* Every card carries a quantity select, so the ajax body has to read it. A
       hardcoded 1 here is honoured by the native no-JS POST and silently
       dropped by this path — the worst kind of divergence, because it only
       misfires for the shoppers who DO have JavaScript, which is nearly all of
       them. parseInt of a missing field is NaN and NaN > 0 is false, so a card
       rendered with the picker turned off still adds exactly one. The clamp
       also absorbs a theme script writing junk into the field. */
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = parseInt(qtyField && qtyField.value, 10);
    if (!(qty > 0)) qty = 1;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      // X-Modulo-Internal opts out of the bundle block's in-flight fetch shim.
      // Without it a quick-add landing inside that window is answered with a
      // synthetic 200 {"items":[]} and takes the SUCCESS path on an add that
      // never happened.
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Modulo-Internal': 'product-shelf' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty }],
        sections: sectionList(drawer),
        sections_url: window.location.pathname
      })
    })
      .then(thenJson)
      .then(function (data) {
        button.classList.add('is-added');
        flash(button, button.getAttribute('data-added-label') || 'Added', 1800);
        /* Re-bind: refreshCart may have replaced the node `drawer` points at. */
        var live = refreshCart(drawer, data);
        /* Best-effort only. The sole listener for these repo-wide is our own
           modulo-block-atc-style.js; Dawn uses an internal PubSub. This is not
           "refreshing the cart" — refreshCart is. */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        openDrawer(live);
      })
      .catch(function (err) {
        var reason = (err && err.message) ? err.message : 'Try again';
        flash(button, reason.slice(0, 28), 2600, reason);
      })
      .then(function () { release(card); });
  }

  /* ─── Tabs ─── */
  function activateTab(sectionEl, index) {
    var tabs = sectionEl.querySelectorAll('[data-psh-tab]');
    var panels = sectionEl.querySelectorAll('[data-psh-panel]');
    for (var i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-psh-tab') === String(index);
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].setAttribute('tabindex', on ? '0' : '-1');
    }
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute('data-psh-panel') !== String(index);
    }
  }

  function wireTabs(sectionEl) {
    var tabs = sectionEl.querySelectorAll('[data-psh-tab]');
    if (!tabs.length) return;

    sectionEl.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-psh-tab]');
      if (!tab || !sectionEl.contains(tab)) return;
      activateTab(sectionEl, tab.getAttribute('data-psh-tab'));
      syncAllArrows(sectionEl);
    });

    /* Roving focus. Arrow keys move between tabs, Home/End jump to the ends —
       the ARIA tabs pattern, same as `ft`/`cw`. */
    sectionEl.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-psh-tab]');
      if (!tab || !sectionEl.contains(tab)) return;
      var list = Array.prototype.slice.call(sectionEl.querySelectorAll('[data-psh-tab]'));
      var i = list.indexOf(tab);
      var next = -1;
      if (e.key === 'ArrowRight') next = (i + 1) % list.length;
      else if (e.key === 'ArrowLeft') next = (i - 1 + list.length) % list.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = list.length - 1;
      if (next < 0) return;
      e.preventDefault();
      list[next].focus();
      activateTab(sectionEl, list[next].getAttribute('data-psh-tab'));
      syncAllArrows(sectionEl);
    });
  }

  /* ─── Carousel ─── */
  function shelfStep(shelf) {
    var card = shelf.querySelector('.modulo-psh__card');
    if (!card) return shelf.clientWidth;
    var styles = window.getComputedStyle(shelf);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function syncArrows(panel) {
    var shelf = panel.querySelector('[data-psh-shelf]');
    var prev = panel.querySelector('[data-psh-prev]');
    var next = panel.querySelector('[data-psh-next]');
    if (!shelf || !prev || !next) return;
    /* Math.abs: a spec-compliant RTL scroller runs 0 → negative, so a raw
       comparison would report "at the start" at both ends (the `bs` lesson). */
    var pos = Math.abs(shelf.scrollLeft);
    var max = shelf.scrollWidth - shelf.clientWidth;
    prev.disabled = pos <= 2;
    next.disabled = pos >= max - 2;
  }

  function syncAllArrows(sectionEl) {
    var panels = sectionEl.querySelectorAll('[data-psh-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].hidden) syncArrows(panels[i]);
    }
  }

  function wireCarousel(sectionEl) {
    var panels = sectionEl.querySelectorAll('[data-psh-panel]');
    for (var i = 0; i < panels.length; i++) {
      (function (panel) {
        var shelf = panel.querySelector('[data-psh-shelf]');
        var prev = panel.querySelector('[data-psh-prev]');
        var next = panel.querySelector('[data-psh-next]');
        if (!shelf || !prev || !next) return;

        var dir = window.getComputedStyle(shelf).direction === 'rtl' ? -1 : 1;
        prev.addEventListener('click', function () {
          shelf.scrollBy({ left: -shelfStep(shelf) * dir, behavior: 'smooth' });
        });
        next.addEventListener('click', function () {
          shelf.scrollBy({ left: shelfStep(shelf) * dir, behavior: 'smooth' });
        });
        shelf.addEventListener('scroll', function () { syncArrows(panel); });
        syncArrows(panel);
      })(panels[i]);
    }
  }

  function initSection(sectionEl) {
    /* Per-element flag, not an IIFE-wide early return: a second instance added
       in the theme editor must still bind. */
    if (sectionEl.dataset.pshReady === '1') return;
    sectionEl.dataset.pshReady = '1';

    wireTabs(sectionEl);
    if (sectionEl.classList.contains('modulo-psh--carousel')) wireCarousel(sectionEl);

    sectionEl.addEventListener('change', function (e) {
      var select = e.target.closest('[data-psh-select]');
      if (!select || !sectionEl.contains(select)) return;
      var card = select.closest('[data-modulo-psh-card]');
      if (card) syncVariant(card);
    });

    /* The buy row is a real product form, so this UPGRADES a working native
       POST rather than being the only thing that makes it work. */
    sectionEl.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-psh-form]');
      if (!form || !sectionEl.contains(form)) return;
      var button = form.querySelector('[data-psh-add]');
      if (!button || button.disabled) return;
      e.preventDefault();
      addToCart(form, button, form.closest('[data-modulo-psh-card]'));
    });

    /* A variant may arrive pre-selected from a ?variant= URL, so reconcile the
       price and badge with the select on first paint. */
    var cards = sectionEl.querySelectorAll('[data-modulo-psh-card]');
    for (var i = 0; i < cards.length; i++) syncVariant(cards[i]);
  }

  function bootstrap() {
    var nodes = document.querySelectorAll('[data-modulo-psh]');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Document-level listeners are registered ONCE. The <script> tag is emitted
     per section instance, so two shelves on a page execute this IIFE twice —
     without the guard, every document listener would be double-registered. The
     guard is scoped to the listeners ONLY: per-element init stays keyed on
     dataset.pshReady, so a second instance still binds. */
  if (!window.__moduloPshBound) {
    window.__moduloPshBound = true;

    /* Without this, a section added in the theme editor stays dead until a
       full page reload. */
    document.addEventListener('shopify:section:load', bootstrap);

    /* A resize can cross 860 or 480, which changes the column count and
       therefore whether the rail overflows at all. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nodes = document.querySelectorAll('[data-modulo-psh]');
        for (var i = 0; i < nodes.length; i++) syncAllArrows(nodes[i]);
      }, 100);
    });

    /* Back-navigation restores the DOM verbatim from bfcache, busy flag
       included, which would strand every card the shopper tried. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var cards = document.querySelectorAll('[data-modulo-psh-card]');
      for (var i = 0; i < cards.length; i++) cards[i].dataset.pshBusy = '0';
    });
  }
})();
